import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "loader ml-2"
}

import { withDefaults, useSlots, computed } from 'vue'
  import Button from 'primevue/button'
  import environment from '@/configs/environtment'
  
  interface IPropsButton {
    buttonText: string
    classList?: string 
    isDisabled?: boolean
    isLoading?: boolean  
    outline?: boolean 
    variant?: 'danger' | 'success' | 'info' | 'warning' // New prop for button variants
  }
  
  
export default /*#__PURE__*/_defineComponent({
  __name: 'ButtonVariant',
  props: {
    buttonText: { default: '' },
    classList: { default: 'btn-size-md' },
    isDisabled: { type: Boolean, default: false },
    isLoading: { type: Boolean, default: false },
    outline: { type: Boolean, default: false },
    variant: { default: 'success' }
  },
  emits: ["click"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'click', val: any): void
  }), expose: any, slots: any, attrs: any }) {

const props = __props as { buttonText: string, classList: string, isDisabled: boolean, isLoading: boolean, outline: boolean, variant: 'danger' | 'success' | 'info' | 'warning' }

  
  
  
  
  const isProduction = computed(() => environment.getMode() === 'production')
  
  // Function to get the button color based on the variant
  const getButtonStyles = (variant: string, outline: boolean) => {
    const baseClasses = outline 
      ? 'border-2 focus:ring-2' 
      : 'text-white hover:bg-opacity-80 active:bg-opacity-90'
    
    switch (variant) {
      case 'danger':
        return outline 
          ? `${baseClasses} border-red-600 text-red-600 hover:bg-red-600 hover:text-white focus:ring-red-600`
          : `${baseClasses} bg-red-600 hover:bg-red-700 active:bg-red-800`
      case 'success':
        return outline 
          ? `${baseClasses} border-green-600 text-green-600 hover:bg-green-600 hover:text-white focus:ring-green-600`
          : `${baseClasses} bg-green-600 hover:bg-green-700 active:bg-green-800`
      case 'info':
        return outline 
          ? `${baseClasses} border-blue-600 text-blue-600 hover:bg-blue-600 hover:text-white focus:ring-blue-600`
          : `${baseClasses} bg-blue-600 hover:bg-blue-700 active:bg-blue-800`
      case 'warning':
        return outline 
          ? `${baseClasses} border-yellow-600 text-yellow-600 hover:bg-yellow-600 hover:text-white focus:ring-yellow-600`
          : `${baseClasses} bg-yellow-600 hover:bg-yellow-700 active:bg-yellow-800`
      default:
        return `${baseClasses} bg-green-600 text-white hover:bg-green-700 active:bg-green-800`
    }
  }
  
  // Computed class for the button based on variant and outline prop
  const buttonClass = computed(() => {
    const baseClasses = `flex items-center gap-3 ${isProduction.value ? '' : 'stg'} ${props.classList} ${useSlots().icon && !props.isLoading ? 'btn-icon' : ''}`
    return `${baseClasses} ${getButtonStyles(props.variant ?? 'success', props.outline ?? false)}`
  })
  
  const handleClick = (event: MouseEvent): void => {
    if (!props.isDisabled && !props.isLoading) {
      emit('click', event) 
    }
  }
  
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Button), {
    class: _normalizeClass(_unref(buttonClass)),
    disabled: __props.isDisabled || __props.isLoading,
    onClick: handleClick
  }, {
    default: _withCtx(() => [
      (!__props.isLoading)
        ? _renderSlot(_ctx.$slots, "icon", { key: 0 })
        : _createCommentVNode("", true),
      _createTextVNode(" " + _toDisplayString(__props.buttonText) + " ", 1),
      (__props.isLoading)
        ? (_openBlock(), _createElementBlock("span", _hoisted_1))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }, 8, ["class", "disabled"]))
}
}

})